import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import { Button, Label, Title, TitleH1 } from "components/generic";
import { RoleUser } from "../interfaces/intarfaces";

import {
  ContainerValue,
  ContainerLogin,
  ContainerRedirect,
} from "components/containers";
import { InputLabel, InputLabelPassword, useInput } from "components/Input";

import { useContextHospi } from "context/ContextHospi";
import {
  EMPTY,
  HOST_PROFILEVIEW_ROUTE,
  STUDENT_PROFILEVIEW_ROUTE,
} from "utils/constants";
import { ContainerView } from "components/containers";
import { MenuLeftSide } from "components/MenuLeftSide";
import { MainSide } from "./ProfileUserEdit/styles";
import { theme } from "styles/theme";

// Max width Container
const maxWidthContainer = "600px";

export const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const [loginWrong, setLoginWrong] = React.useState(EMPTY);
  const [changedPassword, setChangedPassword] = React.useState(false);

  const { userStatus } = useContextHospi();
  const user: RoleUser = userStatus || "student";
  const { t, i18n } = useTranslation(user);
  const { t: t_login } = useTranslation("login");
  const email_show = useInput("");
  const password_old = useInput("");
  const password_new = useInput("");
  const password_confirm = useInput("");

  React.useEffect(() => {
    const getID = async () => {
      const { attributes } = await Auth.currentAuthenticatedUser();
      email_show.onChange(attributes.email ?? "");
    };
    getID();
    // eslint-disable-next-line
  }, []);

  const sendFromData = async () => {
    if (password_new.value !== password_confirm.value) {
      setLoginWrong(t_login("error.unequalPasswords"));
    } else {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(
            user,
            String(password_old.value),
            String(password_new.value)
          );
        })
        .then((data) => setChangedPassword((prev) => !prev))
        .catch((err) => {
          console.log(err.message);
          setLoginWrong(err.message);
        });
    }
  };

  const cancel = async () => {
    navigate(
      user === "host" ? `/${i18n.language}${HOST_PROFILEVIEW_ROUTE.slice(5)}` : `/${i18n.language}${STUDENT_PROFILEVIEW_ROUTE.slice(5)}`
    );
  };

  // When changed password
  if (changedPassword)
    return (
      <ContainerLogin>
        <ContainerRedirect>
          <Title m="0 0 24px 0">{t_login("edit.message.title")}</Title>
          <Label lineHeight="150%">{t_login("edit.message.text")}</Label>
        </ContainerRedirect>
        <Button
          main
          fontWeight="400"
          w="100%"
          m="24px 0 0 0"
          onClick={() => {
            setChangedPassword((prev) => !prev);
            navigate(
              user === "host"
                ? `/${i18n.language}${HOST_PROFILEVIEW_ROUTE.slice(5)}`
                : `/${i18n.language}${STUDENT_PROFILEVIEW_ROUTE.slice(5)}`
            );
          }}
        >
          OK
        </Button>
      </ContainerLogin>
    );

  return (
    <ContainerView>
      <MenuLeftSide />
      <MainSide>
        <TitleH1 style={{ width: "100%", maxWidth: maxWidthContainer }}>
          {t_login("edit.title")}
        </TitleH1>
        <ContainerValue maxWidth={maxWidthContainer}>
          <Title m="0 0 24px 0" fontSize="20px">
            {t(`${user}Profile.login.title`)}
          </Title>
          <InputLabel
            {...email_show}
            title={t_login("login.email")}
            type="email"
            disabled
          />
          <InputLabelPassword
            {...password_old}
            title={t_login("login.password")}
            type="password"
            placeholder={t_login("edit.currentPassword")}
            p="24px 0"
          />
          <InputLabelPassword
            {...password_new}
            title={t_login("edit.newPassword")}
            type="password"
            placeholder={t_login("edit.newPassword")}
            p="24px 0"
          />
          <InputLabelPassword
            {...password_confirm}
            title={t_login("edit.confirmPassword")}
            type="password"
            placeholder={t_login("edit.newPassword")}
            p="24px 0"
          />
          <Label
            p="0"
            fontColor={loginWrong === EMPTY ? theme.colors.place : "red"}
            fontWeight="400"
          >
            {loginWrong}
          </Label>
        </ContainerValue>

        <div
          style={{ width: "100%", maxWidth: maxWidthContainer }}
          className="buttonGroup"
        >
          <Button normal onClick={cancel} m="0 24px 0 0">
            {t(`${user}Profile.buttonCancel.title`)}
          </Button>
          <Button main onClick={sendFromData}>
            {t(`${user}Profile.buttonSave.title`)}
          </Button>
        </div>
      </MainSide>
    </ContainerView>
  );
};
